import React from 'react'
import {ActivityIndicator, StyleSheet, View} from 'react-native'

import {ROUTES} from '#/lib/routes/constants'
import {navigateTo} from '#/lib/routes/helpers'
import {isWeb} from '#/platform/detection'
import * as Layout from '#/components/Layout'

export const ConfirmedScreen = () => {
  React.useEffect(() => {
    if (isWeb) {
      navigateTo(ROUTES.CONFIRMED)
    }
  }, [])

  return (
    <Layout.Screen testID="confirmedView">
      <View style={styles.container}>
        <ActivityIndicator size="large" />
      </View>
    </Layout.Screen>
  )
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 100,
    paddingHorizontal: 20,
    alignItems: 'center',
    height: '100%',
  },
})
